import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useMemo } from "react";

import type { SpaceGroupWithSpaces } from "../../Sidebar";
import { SpaceGroupSection } from "./SpaceGroupSection";

export interface SpaceGroupsSectionProps {
  spaceGroupWithSpaces: SpaceGroupWithSpaces[];
}

export const SpaceGroupsSection = ({
  spaceGroupWithSpaces,
}: SpaceGroupsSectionProps) => {
  const sortableItems = useMemo(
    () =>
      spaceGroupWithSpaces.map(spaceGroup => `space-group-${spaceGroup.id}`),
    [spaceGroupWithSpaces],
  );

  return (
    <SortableContext
      items={sortableItems}
      strategy={verticalListSortingStrategy}
    >
      <ul className="flex list-none flex-col gap-y-4">
        {spaceGroupWithSpaces.map((spaceGroup, index) => (
          <li key={spaceGroup.id}>
            <SpaceGroupSection position={index} spaceGroup={spaceGroup} />
          </li>
        ))}
      </ul>
    </SortableContext>
  );
};
